module.exports = __webpack_public_path__ + "img/5_second_rule.b8d8fb00.png";